module.exports = __webpack_public_path__ + "static/media/8MyMoneyMatters-BM.46ac3a8d.JPG";